import { sectionTheme1InfoCard1Object } from "./ExportTheme1InfoCard1Object";
import { sectionTheme1InfoCard2Object } from "./ExportTheme1InfoCard2Object";
import { sectionTheme1InfoCard3Object } from "./ExportTheme1InfoCard3Object";
import { sectionTheme1InfoCard4Object } from "./ExportTheme1InfoCard4Object";
import { sectionTheme1InfoCard5Object } from "./ExportTheme1InfoCard5Object";
import { sectionTheme1InfoCard6Object } from "./ExportTheme1InfoCard6Object";
import { sectionTheme1SectionCard1Object } from "./ExportTheme1SectionCard1Object";



 export const    sectionTheme1InfoCardObject=(type) => {
  if(type=="Card1"){
     return    sectionTheme1InfoCard1Object;
  }
 if(type=="Card2"){
     return    sectionTheme1InfoCard2Object;
  }
 if(type=="Card3"){
     return    sectionTheme1InfoCard3Object;
  }
  if(type=="Card4"){
     return    sectionTheme1InfoCard4Object;
  }
  if(type=="Card5"){
     return    sectionTheme1InfoCard5Object;
  }if(type=="Card6"){
     return    sectionTheme1InfoCard6Object;
  }if(type=="Section1"){
     return    sectionTheme1SectionCard1Object;
  }
 
 } 

